import React from 'react';
import styled from "styled-components";
import { fontFamilyBold, text } from '../../styling/mixins/typography';
import LinkModel from '../../Types/LinkModel';

const StyledMegaMenuBannerContainer = styled.div`
    text-align: center;
    padding: 1.6rem;
    
    h6 {
        margin-top: 0.8rem;
        margin-bottom: 0.4rem;
        ${text('medium')}
        ${fontFamilyBold}
    }

    div {
        ${text('small')}
    }
`;

interface MegaMenuBannerBlockProps {
    title: string;
    text: string;
    link: LinkModel;
    imageUrl: string;
    imageAlt: string;
}

const MegaMenuBannerBlock = (props: MegaMenuBannerBlockProps) => {
    const title = props.title;
    const text = props.text;
    const url = props.link?.href;
    const imageUrl = props.imageUrl;
    const imageAlt = props.imageAlt;

    return (
        <StyledMegaMenuBannerContainer>
            <a href={url}>
                {imageUrl && imageUrl != "" &&
                    <img src={imageUrl} alt={imageAlt} />
                }
                {title && title != "" &&
                    <h6>{title}</h6>
                }
                {text && text != "" &&
                    <div dangerouslySetInnerHTML={{ __html: text }}></div>
                }
            </a>
        </StyledMegaMenuBannerContainer>
    )
}

export default MegaMenuBannerBlock;